const portfolioSwiper = new Swiper(".swiper-container", {
  slidesPerView: "auto",
    speed: 550,
    loop: false,
    navigation: {
      nextEl: ".slider__next",
      prevEl: ".slider__prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      breakpoints: {
        320: {
          slidesPerView: 1.5
        },
        720: {
          slidesPerView: 2
        },
        1200: {
          slidesPerView: 3
        }
      }
  });